import { Component, Inject, OnInit, Optional } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AltroSoggetto } from "src/app/models/altro-soggetto";
import { AltroSoggettoService } from "src/app/services/altro-soggetto.service";
import { BaseEditForm } from "src/app/shared/baseEditForm";
import { findInRoute } from "src/app/shared/utilities";

@Component({
  selector: "altri-soggetti-form",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class AltriSoggettiFormComponent extends BaseEditForm implements OnInit {
  altroSoggetto: AltroSoggetto;
  form: FormGroup;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private toast: ToastrService,
    private altroSoggettoService: AltroSoggettoService,
    @Optional() public dialogRef: MatDialogRef<AltriSoggettiFormComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: AltroSoggetto
  ) {
    super();
    this.altroSoggetto = data;
  }

  async ngOnInit() {
    const idAltroSoggetto = findInRoute("idAltroSoggetto", this.route);
    if (idAltroSoggetto) {
      this.altroSoggetto = await this.altroSoggettoService.getOne(
        +idAltroSoggetto,
        ["comune", "tipo"]
      );
    }

    this.form = this.fb.group({
      tipo: [this.altroSoggetto?.tipo],
      nome: [this.altroSoggetto?.nome],
      cognome: [this.altroSoggetto?.cognome],
      via: [this.altroSoggetto?.via],
      civico: [this.altroSoggetto?.civico],
      comune: [this.altroSoggetto?.comune],
      cap: [this.altroSoggetto?.cap],
      partita_iva: [this.altroSoggetto?.partita_iva],
      codice_fiscale: [this.altroSoggetto?.codice_fiscale],
      IBAN: [this.altroSoggetto?.IBAN],
      note: [this.altroSoggetto?.note],
      tel: [this.altroSoggetto?.tel],
      fax: [this.altroSoggetto?.fax],
      cell: [this.altroSoggetto?.cell],
      email: [this.altroSoggetto?.email],
      sdi: [this.altroSoggetto?.sdi],
    });
  }

  async handleSuccessfulSubmit() {
    try {
      console.log(this.altroSoggetto);
      let result;

      //edit existing altroSoggetto or create new one
      if (this.altroSoggetto?.id) {
        Object.assign(this.altroSoggetto, this.form.value);
        await this.altroSoggettoService.edit(this.altroSoggetto);
        result = this.altroSoggetto;
      } else {
        result = await this.altroSoggettoService.create(this.form.value);
      }

      this.toast.success(`Altro soggetto salvato`);

      // If in dialog mode, close with the created/edited altroSoggetto
      if (this.dialogRef) {
        this.dialogRef.close(result);
      }
    } catch (e) {
      this.toast.error("Impossibile salvare altro soggetto");
      console.error(e);
    }
  }
}
